import React from 'react';
import PropTypes from 'prop-types';
import ScrollAnimation from 'react-animate-on-scroll';
import { Parallax } from 'react-scroll-parallax';
import LazyBg from '../../../UI/LazyImage/LazyBg';
import { createMarkup } from '../../../../utils/helpers';
import './ExpertiseBody.css';

// @TODO: hard coded content which will need to be refactored for CMS integration
const ExpertiseBody = ({ index, blockData }) => {
    const { title, subtitle, description, pretitle, box_text_image, box_items } = blockData;

    return (
        <section className={`section expertise-body expertise-body-${index}`}>
            <div className="container">
                <div className="columns">
                    <div className="column is-10-tablet is-offset-1-tablet is-11-desktop">
                        {<ScrollAnimation
                            duration={0.85}
                            animateOnce={true}
                            animateIn="fadeInLeft"
                            initiallyVisible={false}>
                            <div className="pre-title">{pretitle}</div>
                        {/* </ScrollAnimation>}
                        {<ScrollAnimation
                            duration={0.65}
                            animateOnce={true}
                            animateIn="fadeInLeft"
                            initiallyVisible={false}> */}
                            <div className="big-title" dangerouslySetInnerHTML={createMarkup(title)} />
                        {/* </ScrollAnimation>}
                        {<ScrollAnimation
                            duration={0.65}
                            animateOnce={true}
                            animateIn="fadeInLeft"
                            initiallyVisible={false}> */}
                            <div className='subtitle'>{subtitle}</div>
                        {/* </ScrollAnimation>}
                        {<ScrollAnimation
                            duration={0.65}
                            animateOnce={true}
                            animateIn="fadeInLeft"
                            initiallyVisible={false}> */}
                            <div className='description'>{description}</div>
                        </ScrollAnimation>}

                        <div className='box-text-image'>
                            <div className="columns is-multiline ">
                                <div className="column is-12-tablet is-6-desktop blue-box-left">
                                    <div className="blue-box-internal">
                                        {box_text_image.title && <div className='box-title'>{box_text_image.title}</div>}
                                        {box_text_image.post_title && <div className='box-post-title'>{box_text_image.post_title}</div>}
                                        {box_text_image.sub_title && <div className='box-sub-title'>{box_text_image.sub_title}</div>}
                                        {box_text_image.description && <div className='box-description'>{box_text_image.description}</div>}
                                        {box_text_image.author && <div className='box-author'>{box_text_image.author}</div>}
                                        {box_text_image.company && <div className='box-company'>{box_text_image.company}</div>}
                                    </div>
                                </div>
                                <div className="column is-12-tablet is-5-desktop image-box">
                                    <div className="parallax-image column">
                                        <div className={`ratio is-relative svg-yellow-triangle ${index === 3 ? 'bottom-right-ver is-3-2' : 'top-right-ver is-3-2 '}`}>
                                            <div className="content">
                                                <div className="parallax-wrapper">
                                                    <Parallax
                                                        className="parallax-window"
                                                        y={[ -19, 13 ]}
                                                    >
                                                        <LazyBg className="asset-container" src={require('./images' + box_text_image.backgroundImage)} />
                                                    </Parallax>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {box_items && <div className="columns is-multiline ">
                                <div className="column is-12-desktop">
                                    <div className='box-overlay'>
                                        <ul className='items'>
                                            {box_items.map((lineText, index) =>
                                                <li key={index}>
                                                    {lineText}
                                                </li>
                                            )}
                                        </ul>
                                    </div>
                                </div>
                            </div>}

                        </div>
                    </div>
                </div>
            </div>
        </section >
    );
};

ExpertiseBody.propTypes = {
    blockData: PropTypes.object,
    index: PropTypes.number,
};


export default ExpertiseBody;
